module.exports = __webpack_public_path__ + "img/placeholder.e01d8b7a.png";